import cx from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { Avatar } from 'common/components/canonical-components/canonical-card';
// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { MemberModel } from 'types';
import styles from './member-avatar.less';
const format = forTemplate('member');

export interface MemberAvatarProps {
  className?: string;
  member?: MemberModel;
  resolution?: 30 | 50 | 170; // image source size
  size?: number; // pixels
  onClick?: React.EventHandler<React.SyntheticEvent>;
  gold?: boolean;
  hoverable?: boolean;
  admin?: 'board' | 'organization';
}

export const MemberAvatar = ({
  className = '',
  member,
  resolution = 30,
  size,
  onClick,
  gold = false,
  hoverable,
  admin,
}: MemberAvatarProps) => {
  if (!member) {
    return <span />;
  }
  const interactive = hoverable || !!onClick;

  return (
    <div
      className={cx(className, styles.memberAvatar)}
      title={`${member.name} (${member.username})`}
      onClick={onClick}
      role={onClick && 'button'}
    >
      <Avatar
        key={member.id}
        className={cx(
          interactive && styles.hoverable,
          member.avatars ? styles.withImage : null,
        )}
        img={member.avatars && member.avatars[30]}
        img2x={member.avatars && member.avatars[resolution === 30 ? 50 : 170]}
        initials={member.initials}
        size={size}
      />
      {gold && (
        <span
          className={styles.gold}
          title={format('this-member-has-trello-gold')}
        />
      )}
      {admin && (
        <span
          className={styles.admin}
          title={format(`this-member-is-an-admin-of-this-${admin}`)}
        />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./app/gamma/src/components/member-avatar/member-avatar.tsx